import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'
import { EnterAddressCommon } from 'pages/settings/ui/EnterAddressCommon'

export const EnterAddress = observer(() => {
  const {
    textEnableLandlineStore: { enterNumberStore, enterAddressStore },
  } = useNewInboxStepsContext()
  const { phone } = enterNumberStore

  useEffect(() => {
    enterAddressStore.init()
  }, [])

  return <EnterAddressCommon phone={phone} enterAddressStore={enterAddressStore} />
})
